import clsx from 'clsx'
import React from 'react'

import ExternalLink from './ExternalLink'

interface BrandLinkProps extends React.HTMLAttributes<HTMLAnchorElement> {
  url: string
  name: string
  affiliate?: boolean
}

export const BrandLink: React.FC<BrandLinkProps> = ({ url, name, affiliate, className, children, ...props }) => (
  <ExternalLink
    href={url}
    title={name}
    sponsored={affiliate}
    className={clsx(className, {
      'plausible-event-name=brandLinkClick': true,
    })}
    {...props}
  >
    {children || name}
  </ExternalLink>
)
